import { getDigitalWellBeingPreviewPath } from 'utils/digitalWellBeingHelpers'
import { getCourseInstancePath } from 'components/dashboard/ClassCard/helpers'

import { UNIT_ROUTE_PRODUCT_NAMES } from './constants'

const normalizeCourseSlug = course => {
  return String(course || '')
    .trim()
    .replace(/^\/+|\/+$/g, '')
}

export function courseSelectHandlerFactory(productName, navigationEvent) {
  return courseOrSlug => () => {
    if (productName === 'digital-well-being') {
      return navigationEvent(
        getDigitalWellBeingPreviewPath({ course: courseOrSlug }),
      )
    }

    return navigationEvent(
      `/product/${productName}/lessons/preview/${courseOrSlug}`,
    )
  }
}

export function classSelectHandlerFactory(
  productName,
  navigationEvent,
  locationSearch = '',
) {
  return (course, instance) => () => {
    const normalizedCourse = normalizeCourseSlug(course)

    if (productName === 'digital-well-being') {
      const currentQuery = new URLSearchParams(locationSearch || '')
      const nextQuery = new URLSearchParams()
      nextQuery.set('class', String(instance || ''))

      const siteId = currentQuery.get('site')
      if (siteId) {
        nextQuery.set('site', siteId)
      }

      navigationEvent(
        `/product/${productName}/lessons/teach/${normalizedCourse}?${nextQuery.toString()}`,
      )
      return
    }

    const usesUnitRoute = UNIT_ROUTE_PRODUCT_NAMES.includes(productName)

    if (usesUnitRoute) {
      const path = getCourseInstancePath({
        program: productName,
        gradeDisplayTitle: normalizedCourse,
        instance,
        tier: 1,
      })
      navigationEvent(path)
      return
    }

    navigationEvent(
      `/product/${productName}/lessons/teach/${normalizedCourse}?class=${instance}`,
    )
  }
}

export function gotoDashboardHandlerFactory(navigationEvent) {
  return () => navigationEvent('/')
}
